import { CreateDocumentFileRequestIsolated, createDocumentFileIsolated } from 'commons/service/client/documentFile'
import { DocumentFile } from 'commons/types/DTO/client/documentFile'
import { WriteHook, useMutationManager } from 'state-manager'

export const useCreateDocumentFileIsolated: WriteHook<CreateDocumentFileRequestIsolated, DocumentFile> = (opts) =>
  useMutationManager<CreateDocumentFileRequestIsolated, DocumentFile>(createDocumentFileIsolated, opts)
